import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MessageService } from 'src/app/service/common/message.service';
import { SupportService } from 'src/app/service/common/support.service';
import { ClientService } from 'src/app/service/pages/client.service';

@Component({
  selector: 'app-client-modal',
  templateUrl: './client-modal.component.html',
  styleUrls: ['./client-modal.component.css']
})
export class ClientModalComponent implements OnInit {

  private _subs : Subscription = new Subscription();
  titles : any;
  constructor(
    private supportService : SupportService,
    private msgService : MessageService,
    private clientService : ClientService,
    private dialogRef : MatDialogRef<ClientModalComponent>,
  ) { 
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this._subs.add(
      this.supportService.getNames('titles').subscribe(res => {
        if(res.status == 'ok'){
          this.titles = res.data;
        }
      })
    )
  }

  saveClient(clientData){
    this._subs.add(
      this.clientService.saveClient(clientData).subscribe(res=> {
        if(res.status == 'ok'){
          this.msgService.success(res.message);
          this.dialogRef.close(res.data);
        }else{
          this.msgService.error(res.message);
        }
      })
    )
  }

  closeModal(){
    this.dialogRef.close(null);
  }

  ngOnDestroy(){
    this._subs.unsubscribe();
  }

}
